import React from 'react';
import { Button, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface EdgeActionButtonsProps {
	showAddLanding?: boolean;
	showAddStair?: boolean;
	onAddLanding?: () => void;
	onAddStair?: () => void;
	disabled?: boolean;
}

const EdgeActionButtons: React.FC<EdgeActionButtonsProps> = ({
	showAddLanding = false,
	showAddStair = false,
	onAddLanding,
	onAddStair,
	disabled = false,
}) => {
	const theme = useTheme();

	const buttonStyles = {
		textDecoration: 'underline',
		fontSize: 'xs',
		fontWeight: 500,
		color: theme.palette.text.primary,
		p: theme.spacing(0.25),
		minWidth: 'auto',
		textTransform: 'none' as const,
		justifyContent: 'flex-start',
		'&:hover': {
			backgroundColor: theme.palette.action.hover,
			textDecoration: 'underline',
		},
		'&:focus': {
			backgroundColor: theme.palette.action.hover,
			textDecoration: 'underline',
		},
		'&.Mui-disabled': {
			color: theme.palette.action.disabled,
			textDecoration: 'none',
		},
	};

	if (!showAddLanding && !showAddStair) {
		return null;
	}

	return (
		<Stack direction="column" spacing={0.5} alignItems="flex-start">
			{showAddLanding && onAddLanding && (
				<Button
					variant="text"
					onClick={onAddLanding}
					disabled={disabled}
					sx={buttonStyles}
					aria-label="Add Landing to this edge"
				>
					Add Landing
				</Button>
			)}
			{showAddStair && onAddStair && (
				<Button
					variant="text"
					onClick={onAddStair}
					disabled={disabled}
					sx={buttonStyles}
					aria-label="Add Stair to this edge"
				>
					Add Stair
				</Button>
			)}
		</Stack>
	);
};

export default EdgeActionButtons;
